// formConfig.js (Modelos Veiculares)

export const formStructure = [
  // Row 0
  [
    {
      name: 'Descricao',
      label: 'Descricao',
      component: 'FormField',
      type: 'text',
      placeholder: 'Ex.: Carreta LS',
      colProps: { md: 12 },
      maxLength: 100,
      required: true,
      validation: { required: 'Descricao e obrigatoria' },
    },
  ],

  // Row 1
  [
    {
      name: 'CodigoInterno',
      label: 'Codigo Interno',
      component: 'FormField',
      type: 'number',
      placeholder: 'Ex.: 101',
      colProps: { md: 6 },
      min: 0,
      step: '1',
    },
    {
      name: 'CodigoIntegracao',
      label: 'Codigo de Integracao',
      component: 'FormField',
      type: 'number',
      placeholder: 'Ex.: 5001',
      colProps: { md: 6 },
      min: 0,
      step: '1',
    },
  ],

  // Row 2
  [
    {
      name: 'NomeTipoModeloVeicular',
      label: 'Tipo de Modelo (Nome)',
      component: 'FormField',
      type: 'text',
      placeholder: 'Ex.: Cavalo Mecanico',
      colProps: { md: 6 },
      maxLength: 100,
    },
    {
      name: 'CodigoTipoModeloVeicular',
      label: 'Tipo de Modelo (Codigo)',
      component: 'FormField',
      type: 'text',
      placeholder: 'Ex.: TRK, SR, VAN',
      colProps: { md: 6 },
      maxLength: 20,
    },
  ],

  // Row 3
  [
    {
      name: 'UnidadeCapacidade',
      label: 'Unidade de Capacidade',
      component: 'FormField',
      type: 'select',
      options: [
        { label: 'Selecione...', value: '' },
        { label: 'kg', value: 'KG' },
        { label: 'ton', value: 'TON' },
        { label: 'm3', value: 'M3' },
        { label: 'pallet', value: 'PALLET' },
        { label: 'unidade', value: 'UN' },
      ],
      colProps: { md: 6 },
    },
    {
      name: 'CodigoTipoCargaANTT',
      label: 'Codigo Tipo Carga ANTT',
      component: 'FormField',
      type: 'text',
      placeholder: 'Ex.: 01',
      colProps: { md: 6 },
      maxLength: 20,
    },
  ],

  // Row 4
  [
    {
      name: 'CapacidadeModelo',
      label: 'Capacidade do Modelo',
      component: 'CurrencyInput',
      prefix: '',
      fixedDecimalScale: false,
      placeholder: '0,00',
      colProps: { md: 6 },
      step: '0.01',
      min: '0',
      max: '99999999.99',
    },
    {
      name: 'NumeroEixos',
      label: 'Numero de Eixos',
      component: 'FormField',
      type: 'number',
      placeholder: 'Ex.: 3',
      colProps: { md: 6 },
      step: '1',
      min: '0',
    },
  ],

  // Row 5
  [
    {
      name: 'OcupacaoCubicaPallets',
      label: 'Ocupacao Cubica (pallets)',
      component: 'CurrencyInput',
      placeholder: '0,00',
      prefix: '',
      colProps: { md: 3 },
      step: '0.01',
      min: '0',
      max: '99999999.99',
    },
    {
      name: 'OcupacaoCubicaMaxima',
      label: 'Ocupacao Cubica Maxima',
      component: 'CurrencyInput',
      placeholder: '0,00',
      prefix: '',
      colProps: { md: 3 },
      step: '0.01',
      min: '0',
      max: '99999999.99',
    },
    {
      name: 'QuantidadePallet',
      label: 'Quantidade de Pallet',
      component: 'CurrencyInput',
      placeholder: '0,00',
      prefix: '',
      colProps: { md: 3 },
      step: '0.01',
      min: '0',
      max: '99999999.99',
    },
    {
      name: 'CapacidadeMaximoPallets',
      label: 'Capacidade Maxima Pallets',
      component: 'CurrencyInput',
      placeholder: '0,00',
      prefix: '',
      colProps: { md: 3 },
      step: '0.01',
      min: '0',
      max: '99999999.99',
    },
  ],

  // Row 6
  [
    {
      name: 'ToleranciaMinimaPallets',
      label: 'Tolerancia Minima (pallets)',
      component: 'CurrencyInput',
      placeholder: '0,00',
      prefix: '',
      colProps: { md: 6 },
      step: '0.01',
      min: '0',
      max: '99999999.99',
    },
    {
      name: 'ToleranciaMinimaCarregamento',
      label: 'Tolerancia Min. Carregamento',
      component: 'CurrencyInput',
      placeholder: '0,00',
      prefix: '',
      colProps: { md: 6 },
      step: '0.01',
      min: '0',
      max: '99999999.99',
    },
  ],

  // Row 7
  [
    {
      name: 'QuantidadeExtraExcedenteTolerado',
      label: 'Qtde Extra Excedente Tolerada',
      component: 'CurrencyInput',
      placeholder: '0,00',
      prefix: '',
      colProps: { md: 6 },
      step: '0.01',
      min: '0',
      max: '99999999.99',
    },
    {
      name: 'ToleranciaExtra',
      label: 'Tolerancia Extra',
      component: 'CurrencyInput',
      prefix: '',
      placeholder: '0,00',
      colProps: { md: 6 },
      step: '0.01',
      min: '0',
      max: '99999999.99',
    },
  ],
];

export const formSections = (initialValues) => ([
  {
    title: `Detalhes do Modelo Veicular ${initialValues?.Descricao ? `- ${initialValues.Descricao}` : ''}`,
    rows: [0, 1, 2, 3, 4, 5, 6, 7],
  },
]);

export const validateForm = (values) => {
  const errors = {};

  if (!values.Descricao || !values.Descricao.trim()) {
    errors.Descricao = 'Descricao e obrigatoria';
  }

  const len = (v) => (typeof v === 'string' ? v.length : 0);
  if (len(values.Descricao) > 100) errors.Descricao = 'Maximo 100 caracteres';
  if (len(values.NomeTipoModeloVeicular) > 100) errors.NomeTipoModeloVeicular = 'Maximo 100 caracteres';
  if (len(values.CodigoTipoModeloVeicular) > 20) errors.CodigoTipoModeloVeicular = 'Maximo 20 caracteres';
  if (len(values.UnidadeCapacidade) > 20) errors.UnidadeCapacidade = 'Maximo 20 caracteres';
  if (len(values.CodigoTipoCargaANTT) > 20) errors.CodigoTipoCargaANTT = 'Maximo 20 caracteres';
  if (len(values.Situacao) > 50) errors.Situacao = 'Maximo 50 caracteres';

  ['CodigoInterno', 'CodigoIntegracao', 'NumeroEixos'].forEach((field) => {
    const v = values[field];
    if (v !== '' && v !== null && v !== undefined) {
      const n = Number(v);
      if (!Number.isInteger(n)) {
        errors[field] = 'Informe um numero inteiro valido';
      } else if (n < 0) {
        errors[field] = 'O valor nao pode ser negativo';
      }
    }
  });

  const parseNumber = (val) => {
    if (val === '' || val === null || val === undefined) return null;
    if (typeof val === 'number') return val;

    let s = String(val).trim();
    if (!s) return null;

    // Keep digits and separators only; normalize decimal separator to '.'.
    s = s.replace(/[^\d.,-]/g, '');

    const lastComma = s.lastIndexOf(',');
    const lastDot = s.lastIndexOf('.');
    const lastSep = Math.max(lastComma, lastDot);

    if (lastSep !== -1) {
      const decimalDigits = s.length - lastSep - 1;
      if (decimalDigits === 2) {
        s = s.replace(/[.,]/g, (match, index) => (index === lastSep ? '.' : ''));
      } else {
        s = s.replace(/[.,]/g, '');
      }
    }

    const n = Number(s);
    return Number.isNaN(n) ? NaN : n;
  };

  [
    'CapacidadeModelo',
    'OcupacaoCubicaPallets',
    'OcupacaoCubicaMaxima',
    'QuantidadePallet',
    'CapacidadeMaximoPallets',
    'ToleranciaMinimaPallets',
    'ToleranciaMinimaCarregamento',
    'QuantidadeExtraExcedenteTolerado',
    'ToleranciaExtra',
  ].forEach((field) => {
    const v = values[field];
    if (v !== '' && v !== null && v !== undefined) {
      const n = parseNumber(v);
      if (Number.isNaN(n)) {
        errors[field] = 'Informe um numero valido (ex.: 1.234,56)';
      } else if (n < 0) {
        errors[field] = 'O valor nao pode ser negativo';
      } else if (n > 99999999.99) {
        errors[field] = 'Nao pode ser maior que 99.999.999,99';
      }
    }
  });

  return errors;
};

